import { isMobile, isTablet } from 'react-device-detect';
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { getNavigationRoutes } from "../../common/utilities/GetNavigationRoutes";
import { leftOuterJoin } from "../../common/utilities/LinqExtensions";
import { useOfflineDetectContext } from "../../contexts/offline-detect-context/UseOfflineDetectContext";
import { useUserContext } from "../../contexts/user-context/UserContext";
import { useRouteContext } from "../../hooks/use-route-context/UseRouteContext";
import { useAvailableViews } from "../../queries/available-views/UseAvailableViews";
import { useQueryNotifications } from "../../queries/UseQueryNotifications";
import { IRoute } from "../../routes/routes";
import { IUICustomizationViewCategorySettingsDTO } from '../../services/ui-customization-data-service/Models';

export default function useCustomizedNavigationRoutes(
    objectType: eLynxObjectTypeEnum,
    objectID: number,
    customizationSettings: IUICustomizationViewCategorySettingsDTO | undefined,
    viewAll: boolean,
): Array<IRoute> {

    const isPhone = isMobile && !isTablet;
    const routeContext = useRouteContext();
    const [offlineState] = useOfflineDetectContext();
    const [userState] = useUserContext();

    const { data: availableViews } = useQueryNotifications(useAvailableViews)({
        customerID: userState.customer?.id as number,
        groupID: routeContext.groupID as number,
        contextObject: {
            id: objectID,
            objectType: objectType
        },
        offline: offlineState.offline
    });

    const navigationRoutes =
        getNavigationRoutes(
            availableViews ?? [],
            isPhone
        )
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

    const customizedRoutes =
        leftOuterJoin(
            navigationRoutes,
            customizationSettings?.views ?? [],
            o => o.viewID!,
            i => i.viewID,
            (o, i) => ({
                ...o,
                hidden: i ? i.hidden : false,
                order: i?.order ?? o.order,
            })
        )
        .where(e => viewAll || !e.hidden)
        .orderBy(e => e.order ?? 9999)
        .toArray();

    return customizedRoutes;
}